import { REPAYMENT_TYPES } from 'loans.module/common/domain/constants.loans';
import { AMORTIZATION } from '../../../common/domain/constants.loans';

class LoansRepaymentModalController {

  constructor($translate, $scope, $filter) {
    'ngInject';
    this.scope = $scope;
    this.translate = $translate;
    this.currency = $filter('currency');
  }

  $onInit(){
    this._translateText();
    this.scope.$watch(() => this.repaymentAmount, () => { this.formatRepaymentDespription(); });
    this.scope.$watch(() => this.repaymentType, () => { this.formatRepaymentDespription(); });
    this.scope.$watch(() => this.feePeriod, () => { this.formatRepaymentDespription(); });
  }
  
  isSuccess() {
    return this.success === true;
  }

  isError() {
    return this.error === true;
  }

  _translateText() {
    this.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MSG_1').then(translation => {
      this.textTranslationMsg1 = translation;

      this.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MSG_2').then(translation => {
        this.textTranslationMsg2 = translation;
      });

      this.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.TOTAL').then(translation => {
        this.successMessageTotal = translation;
      });

      this.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.FEE').then(translation => {
        this.successMessageFee = translation;
      });

      this.translate('LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.PERIOD').then(translation => {
        this.successMessagePeriod = translation;
      });
    });
  }

  getSuccesParcialMessage(){
    if(!this.feePeriod){
      return 'LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.TOTAL';
    }

    if(this.feePeriod === AMORTIZATION.FEE){
      return 'LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.FEE';
    }

    if(this.feePeriod === AMORTIZATION.PERIOD){
      return 'LOANS.REPAYMENT.MODAL.SUCCESS.MESSAGE.PERIOD';
    }
  }

  setSuccesParcialMessage(){
    if(!this.feePeriod){
      this.repaymentDescription = this.successMessage;
    }

    if(this.feePeriod === AMORTIZATION.FEE){
      this.repaymentDescription = this.successMessageFee;
    }

    if(this.feePeriod === AMORTIZATION.PERIOD){
      this.repaymentDescription = this.successMessagePeriod;
    }
  }

  formatRepaymentDespription(){
    if(this.repaymentType === REPAYMENT_TYPES.TOTAL){
      let repaymentAmountFormatted = this.currency(this.repaymentAmount, '' , 2);
      this.repaymentDescription = `${this.textTranslationMsg1} ${repaymentAmountFormatted} ${this.textTranslationMsg2}`;
    }else{
      this.setSuccesParcialMessage();
    }
  }
}

export default LoansRepaymentModalController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentModal/loansRepaymentModal.controller.js